import { render, staticRenderFns } from "./specialDanger.vue?vue&type=template&id=c310e3da"
import script from "./specialDanger.vue?vue&type=script&lang=js"
export * from "./specialDanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports